import type { TNullable } from '@core/models/utility.model';

class AnimationService {
  private frameId: TNullable<number> = null;
  private subscribersCount = 0;
  private readonly speed = 1000;

  public subscribe() {
    this.subscribersCount++;
    if (this.frameId === null) {
      this.startAnimation();
    }
  }

  public unsubscribe() {
    this.subscribersCount--;
    if (this.subscribersCount <= 0) {
      this.stopAnimation();
    }
  }

  private startAnimation() {
    const animate = (time: number) => {
      const angle = Math.round(((time % this.speed) / this.speed) * 360);

      document.documentElement.style.setProperty('--global-rotation', `${String(angle)}deg`);
      this.frameId = requestAnimationFrame(animate);
    };
    this.frameId = requestAnimationFrame(animate);
  }

  private stopAnimation() {
    if (this.frameId !== null) {
      cancelAnimationFrame(this.frameId);
      this.frameId = null;
    }
  }
}

export const animationService = new AnimationService();
